export const reportBaseTranslations = {
  en: {
    summaryTitle: 'Filtered population summary',
    reportRowsTitle: 'Report rows',
    evidenceCoverageTitle: 'Evidence coverage',
    summaryGroupOverview: 'Overview',
    summaryGroupFinance: 'Finance',
    summaryGroupDispatch: 'Dispatch',
    summaryGroupRouting: 'Distance and time',
    summaryGroupCancellation: 'Cancellation',
    summaryGroupEvidence: 'Evidence',
    summaryGroupReasons: 'Reasons',
    summaryShowAll: 'Show all summary · {{count}} more',
    summaryHideAll: 'Hide summary details',
    summaryFinanceReviewWarning: 'Trips requiring financial review: {{count}}',
    allFilterValues: 'All values',
    retainedFilterScope: 'Displayed results: {{filters}} · Data as of {{date}}',
    todayBusinessDate: 'Bangkok business date: {{date}}',
    todayMidnightConflict:
      "The Bangkok business day has changed. Refresh today's report before creating an export; the previously displayed results belong to the earlier day.",
    refreshToday: "Refresh today's report",
    reportExportNotReady:
      'Exports are not enabled yet. Compatible report workers must be deployed before export creation can be enabled.',
    exportLocale: 'CSV language: {{locale}}',
    locale_en: 'English',
    locale_th: 'Thai',
    unit_money: 'THB',
    unit_distance: 'km',
    unit_minutes: 'minutes',
    unit_count: 'count',
    unit_meters: 'm',
    unit_none: '—',
    columnType_text: 'Text',
    columnType_number: 'Number',
    columnType_boolean: 'Yes / no',
    columnType_timestamp: 'Bangkok timestamp',
    columnType_date: 'Bangkok calendar date',
    columnType_list: 'List',
    columnType_money: 'Amount',
    columnType_distance: 'Distance',
  },
  th: {
    summaryTitle: 'สรุปข้อมูลทั้งหมดตามตัวกรอง',
    reportRowsTitle: 'แถวรายงาน',
    evidenceCoverageTitle: 'ความครอบคลุมของหลักฐาน',
    summaryGroupOverview: 'ภาพรวม',
    summaryGroupFinance: 'การเงิน',
    summaryGroupDispatch: 'การจัดสรรงาน',
    summaryGroupRouting: 'ระยะทางและเวลา',
    summaryGroupCancellation: 'การยกเลิก',
    summaryGroupEvidence: 'หลักฐาน',
    summaryGroupReasons: 'เหตุผล',
    summaryShowAll: 'ดูสรุปทั้งหมด · อีก {{count}} รายการ',
    summaryHideAll: 'ซ่อนรายละเอียดสรุป',
    summaryFinanceReviewWarning: '{{count}} เที่ยวต้องตรวจสอบการเงิน',
    allFilterValues: 'ทุกค่า',
    retainedFilterScope: 'ผลที่แสดง: {{filters}} · ข้อมูล ณ {{date}}',
    todayBusinessDate: 'วันธุรกิจตามเวลาไทย: {{date}}',
    todayMidnightConflict:
      'วันธุรกิจตามเวลาไทยเปลี่ยนแล้ว กรุณารีเฟรชรายงานวันนี้ก่อนสร้างไฟล์ส่งออก ผลที่แสดงก่อนหน้านี้เป็นข้อมูลของวันก่อนหน้า',
    refreshToday: 'รีเฟรชรายงานวันนี้',
    reportExportNotReady: 'ยังไม่เปิดการส่งออก ต้องติดตั้งเวิร์กเกอร์ที่รองรับรายงานก่อนเปิดให้สร้างไฟล์ส่งออก',
    exportLocale: 'ภาษา CSV: {{locale}}',
    locale_en: 'อังกฤษ',
    locale_th: 'ไทย',
    unit_money: 'บาท',
    unit_distance: 'กม.',
    unit_minutes: 'นาที',
    unit_count: 'จำนวน',
    unit_meters: 'ม.',
    unit_none: '—',
    columnType_text: 'ข้อความ',
    columnType_number: 'ตัวเลข',
    columnType_boolean: 'ใช่ / ไม่ใช่',
    columnType_timestamp: 'วันและเวลาตามเวลาไทย',
    columnType_date: 'วันที่ตามเวลาไทย',
    columnType_list: 'รายการ',
    columnType_money: 'จำนวนเงิน',
    columnType_distance: 'ระยะทาง',
  },
} as const;
